/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface GetWarsWarIdKillmailsUnprocessableEntity
 */
export interface GetWarsWarIdKillmailsUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof GetWarsWarIdKillmailsUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the GetWarsWarIdKillmailsUnprocessableEntity interface.
 */
export function instanceOfGetWarsWarIdKillmailsUnprocessableEntity(value: object): value is GetWarsWarIdKillmailsUnprocessableEntity {
    return true;
}

export function GetWarsWarIdKillmailsUnprocessableEntityFromJSON(json: any): GetWarsWarIdKillmailsUnprocessableEntity {
    return GetWarsWarIdKillmailsUnprocessableEntityFromJSONTyped(json, false);
}

export function GetWarsWarIdKillmailsUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWarsWarIdKillmailsUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetWarsWarIdKillmailsUnprocessableEntityToJSON(json: any): GetWarsWarIdKillmailsUnprocessableEntity {
    return GetWarsWarIdKillmailsUnprocessableEntityToJSONTyped(json, false);
}

export function GetWarsWarIdKillmailsUnprocessableEntityToJSONTyped(value?: GetWarsWarIdKillmailsUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

